import { TooltipRoot } from "./TooltipRoot";
import { TooltipTrigger } from "./TooltipTrigger";
import { useTooltip } from "./useTooltip";

export const Tooltip = {
  Root: TooltipRoot,
  Trigger: TooltipTrigger,
  store: useTooltip,
};
